import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    useDisclosure,
    Button,
    Text,
    Box,
    ListIcon,
    ListItem,
    List,
    Flex,
  } from "@chakra-ui/react";
  import { COLORS } from "../../../colors";
  import { CheckCircleIcon } from '@chakra-ui/icons';
  
  export default function FormModal({ label }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
  
    return (
      <>
        <Button
          onClick={onOpen}
          rounded={"full"}
          size={"lg"}
          fontWeight={"normal"}
          px={6}
          bg={COLORS.brand1}
          color={COLORS.brand4}
          _hover={{ bg: COLORS.brand3, color: COLORS.brand1}}
          fontFamily={"Montserrat"}
        >
          {label || "Quiero saber más"}
        </Button>
  
        <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody px={0}>
              <Box bg="white" borderRadius="lg" p={7}>
                <Text fontSize={{ base: 18, md: 24 }} fontFamily={"Montserrat"}>
                  Todos nuestros cursos incluyen:
                </Text>
                <List spacing={4} mt={4}>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                        Informes regulares del progreso de los estudiantes.                      
                      </Text>
                    </Flex>
                  </ListItem>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                        La oportunidad de concertar citas para hablar con los profesores a lo largo del curso.
                      </Text>
                    </Flex>
                  </ListItem>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                      	Acceso gratis a los libros de inglés de nuestra Biblioteca.
                      </Text>
                    </Flex>
                  </ListItem>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                      	Consejos sobre materiales para incentivar el aprendizaje fuera del aula.
                      </Text>
                    </Flex>
                  </ListItem>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                      	Tramitación de exámenes oficiales.
                      </Text>
                    </Flex>
                  </ListItem>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                      	Una vez al año hacemos un simulacro de exámenes de Cambridge para que pueda inscribirse en el examen con confianza.
                      </Text>
                    </Flex>
                  </ListItem>
                  <ListItem>
                    <Flex align="center">
                      <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
                      <Text textAlign="justify" ml={2}>
                      	Seguridad: garantizamos la seguridad de nuestros alumnos mediante un adecuado control de las salidas y entradas al Centro.
                      </Text>
                    </Flex>
                  </ListItem>
                </List>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    );
  }
  